import { render, staticRenderFns } from "./ConversationParticipant.vue?vue&type=template&id=c52358f8&scoped=true&"
import script from "./ConversationParticipant.vue?vue&type=script&lang=js&"
export * from "./ConversationParticipant.vue?vue&type=script&lang=js&"
import style0 from "./ConversationParticipant.vue?vue&type=style&index=0&id=c52358f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52358f8",
  null
  
)

export default component.exports